import Constants from './const';

export const rulersForDpi = (currentDpi) => {
  const dpis = Object.keys(Constants.dpi.rulers);
  const nextIndex = dpis.findIndex((dpi) => currentDpi < dpi);
  if (nextIndex > -1) {
    const key = dpis[nextIndex - 1];
    if (key) { return Constants.dpi.rulers[key]; }
    return Constants.dpi.rulers[Constants.dpi.minRulers];
  }
  return Constants.dpi.rulers[Constants.dpi.maxRulers];
};
